import axios from 'axios';

// react-select loadOptions for picking Customers to report on — archived and
// inactive Customers too, so past sales can still be looked up. Used by the
// Sales by Period chart and the Sales Order list's Customers filter.
export default function loadCustomerOptions(search) {
  return axios.get('/api/customers', { params: { status: 'all', include_archived: 'true', search, limit: 20 } })
    .then((res) => (res.data.data || []).map((c) => {
      const note = c.is_archived ? 'Archived' : (c.is_active === false ? 'Inactive' : '');
      return { value: c.id, label: note ? `${c.name} (${note})` : c.name };
    }))
    .catch(() => []);
}
